import { useState } from "react";
import { NodeViewWrapper, NodeViewContent, NodeViewProps } from "@tiptap/react";
import { createPortal } from "react-dom";
import cx from "classnames";
import { FloatingFocusManager } from "@floating-ui/react";

import { BaseEditor } from "../../BaseEditor";
import { NoNewLine } from "../NoNewLine";
import { usePoppable } from "@/hooks/usePoppable";

import styles from "./Footnote.module.css";

export function FootnoteComponent(props: NodeViewProps) {
  const [value, setValue] = useState("");

  function onDismiss() {
    if (value === "") {
      props.deleteNode();
      props.editor.commands.focus();
    }
  }

  const {
    style,
    isPoppableVisible,
    refs,
    context,
    setIsPoppableVisible,
    getFloatingProps,
    getReferenceProps,
  } = usePoppable({
    onDismiss,
    isVisible: true,
    placement: "right",
    options: { offset: 8 },
  });

  const className = cx(
    "relative -translate-y-0.5 hover:cursor-pointer outline-none ml-1 bg-slate-200 text-xs font-bold w-6 h-6 inline-flex items-center justify-center rounded-sm font-sans hover:bg-slate-300",
    { "ring-2 ring-slate-300": isPoppableVisible }
  );

  return (
    <NodeViewWrapper as="span">
      <button
        contentEditable={false}
        ref={refs.setReference}
        data-footnote-num={props.node.textContent}
        onClick={() => setIsPoppableVisible(true)}
        className={className}
        {...getReferenceProps()}
      >
        <NodeViewContent contentEditable={false} />
      </button>
      {isPoppableVisible &&
        createPortal(
          <FloatingFocusManager context={context}>
            <div ref={refs.setFloating} style={style} {...getFloatingProps()}>
              <BaseEditor
                autoFocus
                placeholder="Write your footnote..."
                className={cx("w-72 p-2 rounded-sm text-base", styles.Editor)}
                onUpdate={(value) => setValue(value)}
                extensions={[NoNewLine]}
              />
            </div>
          </FloatingFocusManager>,
          document.getElementById("editor-area") as HTMLDivElement
        )}
    </NodeViewWrapper>
  );
}
